export default function Footer() {
  return (
    <footer className="relative w-full bg-blue-600 text-white py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-lg md:text-xl font-bold mb-3">
          unicloud
        </h2>
        <p className="font-body text-sm text-blue-100 max-w-sm mx-auto leading-relaxed mb-8">
          最後までご覧いただきありがとうございます。
          各種SNSでも最新情報を発信中です。
        </p>

        <div className="flex items-center justify-center gap-6 mb-8">
          <a
            href="https://x.com/ikeunicloud"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-500 hover:bg-blue-400 transition-colors duration-300 cursor-pointer"
            aria-label="X (Twitter)"
          >
            <i className="ri-twitter-x-line text-lg"></i>
          </a>
          <a
            href="https://note.com/unicloud"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-500 hover:bg-blue-400 transition-colors duration-300 cursor-pointer"
            aria-label="note"
          >
            <i className="ri-article-line text-lg"></i>
          </a>
          <a
            href="https://ike-unicloud.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-500 hover:bg-blue-400 transition-colors duration-300 cursor-pointer"
            aria-label="Homepage"
          >
            <i className="ri-global-line text-lg"></i>
          </a>
        </div>

        <p className="font-label text-xs text-blue-200">
          &copy; 2026 unicloud. All rights reserved.
        </p>
      </div>
    </footer>
  );
}